import { ApiLambdalerAuthHeaderSchema } from '@eigtech/lambdaler-api-gateway-types';
import { CornSchema } from '@eigtech/shared-corn';
import { z } from 'zod';
export const GetMeetingUploadApiSchema = {
    params: z.object({
        entityId: CornSchema,
    }),
    query: z.object({
        isMultipartMeetingUpload: z.enum(['true', 'false']).optional(),
        startTime: z.string().datetime().optional(),
    }),
    headers: ApiLambdalerAuthHeaderSchema.required({ requestActor: true }),
    response: z.object({
        fields: z.record(z.string(), z.string()),
        url: z.string(),
    }),
};
export const GetMeetingUploadUrlRequestSchema = GetMeetingUploadApiSchema.params
    .merge(GetMeetingUploadApiSchema.headers)
    .merge(GetMeetingUploadApiSchema.query);
